module.exports = __webpack_public_path__ + "img/product-preview-25.b79033e.png";